import Vue from "vue";
import VueRouter from "vue-router";


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/pc/welcome.vue"),
  },
  {
    path: "/mobile",
    name: "mobile",
    component: () => import("@/views/mobile/mobile.vue"),
  },
  {
    path: "/welcome",
    name: "welcome",
    component: () => import("@/views/pc/welcome.vue"),
  },
  {
    path: "/page1",
    name: "page1",
    component: () => import("@/views/pc/page1.vue"),
  },
  {
    path: "/page2",
    name: "page2",
    component: () => import("@/views/pc/page2.vue"),
  },
  {
    path: "/page3",
    name: "page3",
    component: () => import("@/views/pc/page3.vue"),
  },
  {
    path: "/page4",
    name: "page4",
    component: () => import("@/views/pc/page4.vue"),
  },
];

const router = new VueRouter({
  routes,
  mode: "hash",
});

export default router;
